export default {
  campaignTypes: [],
  campaignTypeCode: null,

  campaigns: [],
  campaign: {},
  campaignCode: null,

  leadTypes: [],
  leadType: {},
  leadTypeCode: null,

  leadPropertys: [],
  leadProperty: {},
  leadPropertyCode: null,

  
  leadSources: [],
  leadSource: {},
  leadSourceCode: null,


  chancePrioritys: [],
  chancePriority: {},
  chancePriorityCode: null,

  failedSaleReasons: [],
  failedSaleReasonCode: null,

  strengthWeaknesses: [],
  strengthWeakness: {},
  strengthWeaknessCode: null,

  leadEvaluationQuestions: [],
  leadEvaluationQuestion: {},
  leadEvaluationQuestionCode: null,

  saleRegions: [],
  saleRegionCode: null,

  saleTeams: [],
  saleTeamCode: null,

  leads: [],
  lead: {},
  leadId: null,
  leadCode: null,
  leadStatistics: {},

  chances: [],
  chance: {},

  competitors: [],
  competitor: {},

  leadAddresses: [],
  leadAddress: {},

  leadContactes: [],
  leadContact: {},

  saleLines: [],
  saleLineCode: null,

  saleStageCode: null,
};
